import React from "react";
import { IngestionJob } from "../../api/ingestionJob";
import { AddUnappliedCashesStep } from "./add-unapplied-cashes-step";
import { ConfirmUnappliedCashesDataStep } from "./confirm-unapplied-cashes-data-step";
import { InblockedUnappliedCashesDataStep } from "./inblocked-unapplied-cashes-data-step";

export const UnappliedCashesWorkflow = ({ isEdit, workflowStep, job, next, back, cancel, startOver, $refreshEvents }:
  { isEdit: boolean, workflowStep: number, job: IngestionJob, next, back, cancel, startOver, $refreshEvents }) => {

  const isAddUnappliedCashesStepEnabled = () => {
    if (isEdit) return false;
    return workflowStep === 1;
  }

  const isConfirmUnappliedCashesDataStepEnabled = () => {
    if (isEdit && workflowStep == 0) return true;
    return workflowStep === 2;
  }

  const isInblockedUnappliedCashesDataStepEnabled = () => {
    if (isEdit && workflowStep == 1) return true;
    return workflowStep === 3;
  }

  return <>
    {isAddUnappliedCashesStepEnabled() && <AddUnappliedCashesStep job={job} next={next} back={back} cancel={cancel} />}
    {isConfirmUnappliedCashesDataStepEnabled() && <ConfirmUnappliedCashesDataStep isEdit={isEdit} job={job} next={next} cancel={cancel} startOver={startOver} $refreshEvents={$refreshEvents} />}
    {isInblockedUnappliedCashesDataStepEnabled() && <InblockedUnappliedCashesDataStep job={job} back={back} $refreshEvents={$refreshEvents}/>}
  </>
}
